<template>
  <div class="w98">
   <div class="crumb">
      <span><router-link to="/Help">帮助</router-link>  > </span>
      <span>专题读片</span>
    </div>
     <help-Menu></help-Menu>
    <div class="rightContent">
        <div class="conten">
          <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
                 专题读片
            </template>
            <P  class="text">用户在此可进行专题会议的新建。</P>
            <p  class="text">步骤一：用户点击【新增会议】，在专题会议新增界面，完善基本信息的输入，点击【保存待发】，会议即可保存成功。</p>
            <P  class="text">步骤二：选择“会议类型”，设置密码。类型为“公开”时，可设置密码，也可不设置6位数字密码。类型为“私密”时，不设置密码，但需选择开放范围。</P>
            <P  class="text">步骤三：添加影像、病历、附件。</P>
            <div><img src="../../../../static/image/41.png"/></div>
          </el-collapse-item>
          <el-collapse-item title="会议编辑">
            <p class="text">功能只对会议主持人开放。当“发送状态”为“保存待发”时，点击<b><img  class="littleImg"  src="../../../../static/image/80.png"/></b>，可进入编辑页面进行编辑，完成编辑后，点击：</p>
            <P class="text">一．保存待发，保存后，状态不变</P>
            <P class="text">二．发送，保存后，会议发送状态为“已发送”</P>
          </el-collapse-item>
           <el-collapse-item title="会议发送及撤回">
            <h1 class="titleBar">发送</h1>
            <p class="text">方法一：选择“保存待发”记录，进入编辑详情页面，点击【发送】</p>
            <P class="text">方法二：勾选 “保存待发”记录，点击发送<b><img  class="ltImg"  src="../../../../static/image/81.png"/></b></P>
            <h1 class="titleBar">批量发送</h1>
            <P class="text">勾选 “保存待发”记录，点击发送<b><img  class="ltImg"  src="../../../../static/image/81.png"/></b></P>
            <h1 class="titleBar">撤回</h1>
            <P class="text">只有“发送状态”为“已发送”，并且“会议状态”为“未开始”会议，可以使用撤回功能。</P>
            <P class="text">会议主持人选择需撤回记录 ，点击<b><img  class="littleImg"  src="../../../../static/image/87.png"/></b>，确认后，发送状态即可变为“保存待发”（非主持人无此权限）。</P>
            <h1 class="titleBar">会议隐藏</h1>
            <P class="text">批量勾选记录，点击<b><img  class="ltImg"  src="../../../../static/image/82.png"/></b> ，确认后，所选记录将从列表中除去。此操作不可撤销。</P>
            <h1 class="titleBar">会议查看</h1>
            <P class="text">用户点击<b><img  class="littleImg"  src="../../../../static/image/78.png"/></b>，即可进入查看会议详情。</P>
            <P class="text">如会议设置密码，则需先输入密码。</P>
            <h1 class="titleBar">会议开启</h1>
            <h3 class="text">正常开启:“发送状态”为“已发送”的专题会议， 当会议开始时间到达时，“会议状态”会自动切换为“进行中”，即自动开启。</h3>
            <h3 class="text">提前开启：会议主持人可提前半小时，点击，提前开始会议，此时“会议状态”将提前切换为“进行中”。</h3>
            <P class="text">已结束的会议，如存在会议视频，参会人员可点击【回放录播】，进行视频回放。</P>
            <h1 class="titleBar">会议进入</h1>
            <P class="text">参会人员在“会议状态”变为“进行中”后，可通过点击<b><img  class="littleImg"  src="../../../../static/image/88.png"/></b>，进入会议。</P>
            <h1 class="titleBar">会议结束</h1>
            <P class="text">会议主持人在进入会议后，点击【结束会议】，即可关闭当前会议。参会人员无权限关闭会议。若主持人忘记结束会议，会议会在每日凌晨自动结束。</P>
          </el-collapse-item>
        </el-collapse>

      </div>
    </div>
</div>
</template>

<script type="text/ecmascript-6">
  import {getRightHeight} from '@/common/js/rightHeight'
  import helpHead from '@/components/common/header/helpHead'
  import helpMenu from '@/components/common/helpMenu/helpMenu'
  export default {
    data () {
      return {
         height:''
      }
    },
    components:{
        helpHead,
        helpMenu
    },
      mounted() {
      setTimeout(() => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      }, 20)
      window.addEventListener('resize', () => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      })
    },
}

</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.content
    min-width: 100vw
    height: 100vh
    overflow: hidden
  .rightContent
    position: relative
    float: right
    height :calc(100vh - 80px)
    width: calc(80% - 1px)
    min-width: 919px
    background :#fff
    overflow:auto
  .conten
    padding: 25px 0px 25px 30px
  .text
     color:#555
     line-height: 25px
     text-indent:2em
  .titleBar
     color:#000
     font-size:14px
     font-weight:bolder
  img
   width:80%
  .littleImg
      width:30px
      vertical-align:middle
  .ltImg
      width:70px
      vertical-align:middle
 .crumb
 line-height: 30px
 margin: 5px 0 0 20px

</style>



// WEBPACK FOOTER //
// ThematicReading.vue?000ea6b1